export var COLORS = {
    PRIMARY: '#37576D',
    FILL: 'white',
    TEXT: '#37576D',
    SECONDARY: '#74A4BC',
    HANDLE: '#3370FB',
    SELECTION: '#3899EC',
    HIGHLIGHT: '#4EB7F5',
    DISABLED: 'rgba(163,154,146,0.3)',
    WHITE: '#FFF',
    BLACK: '#000',
    TRANSPARENT: 'transparent',
    SELECTION_LABEL: '#162d3d',
    GRID: '#cbd3dc',
    SECONDARY_SHAPE_STROKE: '#162d3d',
    CLASH_FILL: '#FFE1E1',
    CLASH_BORDER: '#F66',
    SPLASH_BG: '#f0f4f7',
};
export var SEAT_CIRCLE_RADIUS = 12;
export var SEAT_CIRCLE_DIAMETER = SEAT_CIRCLE_RADIUS * 2;
export var OCCUPIED_SEAT_CIRCLE_DIAMETER = 8;
export var OCCUPIED_SEAT_FILL = 'rgba(0, 0, 0, 0.3)';
export var SEAT_SPACING = 12;
export var ROW_SPACING = 12;
export var MIN_TABLE_SIZE = SEAT_CIRCLE_DIAMETER * 4 + SEAT_SPACING * 2;
export var MIN_SHAPE_SIZE = 24;
export var MIN_LINE_LENGTH = 6;
export var MAX_LINE_STROKE_WIDTH = 6;
export var MAX_DIMENSION = 1000000;
export var SHAPE_STROKE_COLOR = COLORS.PRIMARY;
export var SHAPE_FILL_COLOR = 'white';
export var STROKE_WIDTH = 1;
export var STROKE_WIDTH_SELECTED = 2;
export var DEFAULT_TEXT = 'TEXT';
export var AREA_DEFAULT_TEXT = 'General Admission';
export var TEXT_FONT_SIZE = 32;
export var LABEL_FONT_SIZE = 12;
export var LABEL_LINE_HEIGHT = 1.2;
export var LABEL_FONT_FAMILY = 'sans-serif';
export var LABEL_FONT = "normal ".concat(LABEL_FONT_SIZE, "px/").concat(LABEL_LINE_HEIGHT, "px ").concat(LABEL_FONT_FAMILY);
export var HANDLE_TOLERANCE = 3;
export var MAX_SEATS_IN_ROW = 50;
export var MAX_ROWS_IN_MULTIROW = 50;
export var MAX_AREA_CAPACITY = 50000;
export var MAX_SEAT_LABEL_NUMERIC = 999;
export var MAX_SEAT_LABEL_LENGTH = 3;
export var MAX_TEXT_LENGTH = 40;
export var MAX_TABLE_LABEL_LENGTH = 20;
export var MAX_SECTOR_NAME_LENGTH = 20;
export var MAX_SPACING_BETWEEN_SEATS = 60;
export var MAX_SHAPES = 1000;
export var MAX_SHAPES_WARNING_PERCENT = 0.9;
//# sourceMappingURL=constants.js.map